<mat-button-toggle-group (change)="value.set($event.value)"
                         [attr.aria-label]="label()"
                         [hideSingleSelectionIndicator]="true"
                         [value]="value()">
    @for (option of options(); track option.value) {
        <mat-button-toggle [value]="option.value">
            {{ option.label }}
            @if (option.count !== undefined && option.count !== null) {
                <span class="ui-tab-count">{{ option.count }}</span>
            }
        </mat-button-toggle>
    }
</mat-button-toggle-group>
